import * as Yup from "yup";

export default Yup.object().shape({
  email: Yup.string()
    .email("Please use a valid email address.")
    .required("This field is required"),
  password: Yup.string().required("This field is required"),
});
